import router from "@/router";
import Gobalstore from "../index";
export const actions = {
  /* use */
  getEmployee: function (localStore) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "GET",
      url: `/admin/guarded/management/employee/`,
    })
      .then(function (response) {
        localStore.commit("setEmployee", response.data);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  getEmployeeLevel: function (localStore) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "GET",
      url: `/admin/guarded/management/emp_level/`,
    })
      .then(function (response) {
        localStore.commit("setEmployeeLevel", response.data);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  /* use */
  getEmployeeDetail: function (localStore, emp_id) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "GET",
      url: `/admin/guarded/management/employee/${emp_id}`,
    })
      .then(function (response) {
        localStore.commit("setEmployeeDetail", response.data);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  /* use */
  getEmployeeMenu: function (localStore, emp_id) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "GET",
      url: `/admin/guarded/management/employee/menu-right/${emp_id}`,
    })
      .then(function (response) {
        localStore.commit("setEmployeeMenu", response.data);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  /* use */
  getDepaparment: function (localStore) {
    this.axios({
      method: "GET",
      url: `/admin/guarded/department/`,
    }).then(function (response) {
      localStore.commit("setDepartment", response.data);
    });
  },

  /* use */
  createEmployee: function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    var that = this;
    return this.axios({
      method: "POST",
      url: `/admin/guarded/management/employee/`,
      data: payload.data,
      headers: payload.headers
    })
    .then((res) => {
      Gobalstore.commit("LoadingOverlay", false);
      return res;
    })
    .catch((err) => {
      Gobalstore.commit("LoadingOverlay", false);
      return err;
    });
  },

  /* use */
  updateEmployee: function (localStore, payload) {
    return new Promise((resolve, reject) => {
      this.axios({
        method: "PATCH",
        url: `/admin/guarded/management/employee/${payload.data.emp_id}`,
        data: payload.data,
        headers: payload.headers
      })
        .then(function (res) {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  deleteEmployeeMenu: function (localStore, menu) {
    console.log(menu);
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "DELETE",
        url: `/admin/guarded/management/employee/menu-right/${menu.emp_menu.emp_id}/${menu.menu_id}`,
      })
        .then(function (response) {
          resolve(response);
          Gobalstore.commit("LoadingOverlay", false);
        })
        .catch((err) => {
          reject(err);
          Gobalstore.commit("LoadingOverlay", false);
        });
    });
  },

  /* use */
  updateEmployeeMenu: function (localStore, emp_menu) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "PATCH",
        url: `/admin/guarded/management/employee/menu-right/${emp_menu.emp_id}`,
        data: emp_menu,
      })
        .then(function (response) {
          resolve(response);
          Gobalstore.commit("LoadingOverlay", false);
        })
        .catch((err) => {
          reject(err);
          Gobalstore.commit("LoadingOverlay", false);
        });
    });
  },

  updateEmployeeSubMenu: function (localStore, data) {
    console.log(data.action);
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      const menu = data.menu;
      const subMenu = data.sub_menu;
      const empMenu = data.menu.emp_menu;
      let body = {
        ctrl_auth: empMenu.ctrl_auth,
        ctrl_create: empMenu.ctrl_create,
        ctrl_delete: empMenu.ctrl_delete,
        ctrl_update: empMenu.ctrl_update,
        ctrl_view: empMenu.ctrl_view,
        menu_id: menu.menu_id,
        actions: [
          {
            action_id: subMenu.action_id,
            action_right: data.action,
          },
        ],
      };

      this.axios({
        method: "PATCH",
        url: `/admin/guarded/management/employee/menu-right/${empMenu.emp_id}`,
        data: body,
      })
        .then(function (response) {
          resolve(response);
          Gobalstore.commit("LoadingOverlay", false);
        })
        .catch((err) => {
          reject(err);
          Gobalstore.commit("LoadingOverlay", false);
        });
    });
  },

  deleteEmployee: function (localStore, data) {
    this.axios({
      method: "DELETE",
      url: `/admin/guarded/management/employee/disable/${data.emp_id}`,
      data: data,
    })
      .then(function (response) {
        Gobalstore.commit("snackbarSuccess", true);
        localStore.commit("removeEmployee", data);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },
};
